export function sortByMatchPercentage(
  a: { matchPercentage?: number },
  b: { matchPercentage?: number },
) {
  return (b.matchPercentage || 0) - (a.matchPercentage || 0);
}
